module.exports = __webpack_public_path__ + "img/21_19.84751890.png";